<template>
  <div id="modal" class="modal property_disp_modal" v-show="modalShown">
    <div class="modal-main modal-container" id="property_disp_modal">
      <div class="modal-header">表示項目</div>
      <div class="search_content">
        <ul v-if="!isDetailPage">
          <li v-for="(property, index) in propertyList" :key="'property' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.propertyCheckList, property.code)"
                v-model="dispForm.propertyCheckList" :value="property.code"/>
              <label :for="'sl_' + index">{{ property.label }}</label>
          </li>
        </ul>
        <ul v-else>
          <li v-for="(roomPlan, index) in roomPlanList" :key="'roomPlan' + index">
            <input type="checkbox" :id="'sl_' + index" @click="setCheck($event, dispForm.roomPlanCheckList, roomPlan.code)"
                v-model="dispForm.roomPlanCheckList" :value="roomPlan.code"/>
              <label :for="'sl_' + index">{{ roomPlan.label }}</label>
          </li>
        </ul>
      </div>
        <div class="modal-footer">
          <button class="main_btn pos_left" @click="defaultDisp()">デフォルト</button>
          <button class="main_btn pos_right" @click="close()">閉じる</button>
          <button class="main_btn search_btn" @click="disp()">適用</button>
        </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PropertyDispModal',
  components: {
  },
  props: {
    refDispForm: Object,
    defaultDispForm: Object
  },
  data () {
    return {
      isDetailPage: false,
      dispForm: {
        propertyCheckList: [],
        roomPlanCheckList: []
      },
      modalShown: false,
      propertyList: [
        {code: 0, label: '物件コード'},
        {code: 1, label: '物件名'},
        {code: 2, label: '物件住所'},
        {code: 3, label: '顧客会社名'},
        {code: 4, label: '顧客担当者名'},
        {code: 5, label: '見積依頼日'},
        {code: 6, label: '見積依頼番号'},
        {code: 7, label: '見積回答期日'},
        {code: 8, label: '受注ステータス'},
        {code: 9, label: '受注日'},
        {code: 10, label: '注文番号'},
        {code: 11, label: '担当者１'},
        {code: 12, label: '最終更新者'}
      ],
      roomPlanList: [
        {code: 20, label: '棟名'},
        {code: 21, label: 'フロア名'},
        {code: 22, label: 'ルーム名'},
        {code: 23, label: '場所名'},
        {code: 24, label: 'UMコード'},
        {code: 25, label: 'プラン名'},
        {code: 26, label: '数量'},
        {code: 27, label: '納入先名'},
        {code: 28, label: '納入先部署名'},
        {code: 29, label: '納入先担当者名'},
        {code: 30, label: '着荷日'},
        {code: 31, label: '納入時刻'}
      ]
    }
  },
  methods: {
    showModal: function (isDetailPage) {
      this.isDetailPage = isDetailPage
      this.modalShown = true
    },
    disp: function () {
      this.modalShown = false
      this.$emit('onDisp', this.dispForm)
    },
    defaultDisp: function () {
      if (!this.isDetailPage) {
        this.dispForm.propertyCheckList = this.defaultDispForm.propertyCheckList
      } else {
        this.dispForm.roomPlanCheckList = this.defaultDispForm.roomPlanCheckList
      }
    },
    close: function () {
      this.modalShown = false
    },
    setCheck: function (event, checkList, code) {
      if (event.target.checked === true) {
        checkList.push(code)
      } else {
        checkList = checkList.filter(s => s !== code)
      }
    }
  },
  computed: {
  },
  mounted: function () {
  },
  created: function () {
    this.dispForm.propertyCheckList = Object.assign([], this.refDispForm.propertyCheckList)
    this.dispForm.roomPlanCheckList = Object.assign([], this.refDispForm.roomPlanCheckList)
  }
}
</script>

<style src="../../../css/order/order_search.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.modal-container {
  max-width: 30%;
}
input[type="checkbox"] + label {
  min-width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/PropertyDispModal.vue